module.exports = __webpack_public_path__ + "c4a363dd64ae29af674ee7c552510b96.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/press_teaser_201603_sputnika.jpg
// module id = 641
// module chunks = 0